export default __webpack_public_path__ + "static/typography-image-h-1c3568c4c773f4c8f4b6ef9908c6ab09.png";